import VehicleBlockFeatures from './VehicleBlockFeatures';

export default VehicleBlockFeatures;
export { VehicleBlockFeatures };
